import styled from 'styled-components';
import {
  ColorName,
  FontWeightName,
  TextTransformName,
  TextAlignName,
  FontFamily,
} from 'types';

import { getFontScale, FontScaleName } from 'themes/mixins/getFontScale';

export type TextProps = {
  scale?: FontScaleName;
  color?: ColorName;
  fontWeight?: FontWeightName;
  textTransform?: TextTransformName;
  textAlign?: TextAlignName;
  fontFamily?: FontFamily;
};

const Text = styled.p<TextProps>`
  ${getFontScale};

  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.black)};

  font-family: ${({ fontFamily }) => `${fontFamily}, sans-serif`};

  font-weight: ${({ theme, fontWeight }) =>
    fontWeight ? theme.fontWeights[fontWeight] : theme.fontWeights.normal};

  text-transform: ${({ theme, textTransform }) =>
    textTransform ? theme.textTransforms[textTransform] : theme.textTransforms.none};

  text-align: ${({ theme, textAlign }) =>
    textAlign ? theme.textAligns[textAlign] : theme.textAligns.left};
`;

export { Text };
